import { render, staticRenderFns } from "./ButtonAbrirCardapio.vue?vue&type=template&id=17a741f6&scoped=true&"
import script from "./ButtonAbrirCardapio.vue?vue&type=script&lang=js&"
export * from "./ButtonAbrirCardapio.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAbrirCardapio.vue?vue&type=style&index=0&id=17a741f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a741f6",
  null
  
)

export default component.exports